import { Button, Form, Segmented } from "antd";
import { useState } from "react";
import { UserSearchSelect } from "@/components/users/user-search-select";
import { CustomDrawer } from "../layout/workspace/custom-drawer";
import { AgentSelector } from "./agent-selector";

type AssigneeKind = "AGENT" | "USER";

interface AssigneeSelectorDrawerProps {
	open: boolean;
	workspaceId: string;
	assigneeId?: string;
	assigneeType?: AssigneeKind;
	onClose: () => void;
	onConfirm: (id: string, type: AssigneeKind) => void;
}

export function AssigneeSelectorDrawer({
	open,
	workspaceId,
	assigneeId,
	assigneeType,
	onClose,
	onConfirm,
}: AssigneeSelectorDrawerProps) {
	const [form] = Form.useForm();
	const [kind, setKind] = useState<AssigneeKind>(assigneeType ?? "AGENT");
	const values = Form.useWatch([], form);

	const handleConfirm = () => {
		form.validateFields().then((vals) => {
			onConfirm(vals.assigneeId ?? "", kind);
			onClose();
		});
	};

	const handleClose = () => {
		form.resetFields();
		setKind(assigneeType ?? "AGENT");
		onClose();
	};

	const handleKindChange = (val: string | number) => {
		setKind(val as AssigneeKind);
		form.resetFields(["assigneeId"]);
	};

	return (
		<CustomDrawer
			title="Select Assignee"
			open={open}
			onClose={handleClose}
			extra={
				<Button
					type="primary"
					disabled={!values?.assigneeId}
					onClick={handleConfirm}
				>
					Confirm
				</Button>
			}
		>
			<Segmented
				options={[
					{ label: "Agent", value: "AGENT" },
					{ label: "User", value: "USER" },
				]}
				value={kind}
				onChange={handleKindChange}
				style={{ marginBottom: 16 }}
			/>
			<Form
				form={form}
				layout="vertical"
				initialValues={{
					assigneeId: assigneeType === "AGENT" ? assigneeId : undefined,
				}}
			>
				{kind === "AGENT" ? (
					<AgentSelector
						workspaceId={workspaceId}
						onAgentChange={(id) => form.setFieldValue("assigneeId", id)}
					/>
				) : (
					<Form.Item name="assigneeId" label="User">
						<UserSearchSelect workspaceId={workspaceId} />
					</Form.Item>
				)}
			</Form>
		</CustomDrawer>
	);
}
